import React from "react";
import "./IotSol.css";
import compLine from "../Images/compLine.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const iotSol = "/static/media/iot.53ee35bb162687d17876.png";
const iot3 = "/static/media/iot3.57c404bb2e8193117c1b.png";
const fwd = "/static/media/fwd.d5aba7a2b16d2cdc35ce.jpg";
const embed = "/static/media/embed.2d39d6ba226496642f28.jpeg";
const qs = "/static/media/qs.751d4df750c940cc39bb.jpg";
const pcb = "/static/media/pcb.b4e81f70fe3447d4eb3e.jpg";

export default function IotSol() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div id="iotSol">
      <div className="iotSol__head">
        <div className="iotSol__headImg1">
          <img className="iot_img" src={iotSol} alt="IIoT solutions" style={{ marginLeft: "5%" }} />
          <img className="iot_line" src={compLine} alt="" style={{ width: "50%" }} />
        </div>
        <div className="iotSol__headImg2">
          <img className="iot_img2" src={iot3} alt="Industrial IoT" style={{ width: "80%", height: "100%" }} />
        </div>
      </div>

      <div className="iotSol__text">
        <p>
          IIoT (Industrial Internet of Things) solutions integrate smart technologies with industrial processes to enhance efficiency, productivity, and connectivity in various sectors. These solutions leverage data analytics, sensors, and communication networks to enable real-time monitoring, predictive maintenance, and automation. By bridging the gap between physical machinery and digital systems, IIoT drives innovation in manufacturing, energy, logistics, and more. It empowers industries to make informed decisions, reduce operational costs, and adapt to changing market demands.
        </p>
      </div>

      <div className="iotSol__belowhead">
        <div className="iotSol__img">
          <div className="itemwrapper">
            <div className="main2" style={{ backgroundImage: `url(${fwd})` }}>
              <div id="bottom"><div className="back">Firmware Development</div></div>
            </div>
            <div><p className="iotSol_para">Expertise in software and firmware development for IIoT solutions, enabling seamless integration, data processing, and control in industrial environments.</p></div>
          </div>

          <div className="itemwrapper">
            <div className="main2" style={{ backgroundImage: `url(${embed})` }}>
              <div id="bottom"><div className="back">Embedded Engineering</div></div>
            </div>
            <div><p className="iotSol_para">IIoT creates specialized hardware and software for seamless communication, real-time monitoring, and control in industrial environments.</p></div>
          </div>

          <div className="itemwrapper">
            <div className="main2" style={{ backgroundImage: `url(${qs})` }}>
              <div id="bottom"><div className="back">Quality Assurance</div></div>
            </div>
            <div><p className="iotSol_para">Ensure robust, reliable performance, compliance, and security, enhancing industrial processes and operations.</p></div>
          </div>

          <div className="itemwrapper">
            <div className="main2" style={{ backgroundImage: `url(${pcb})` }}>
              <div id="bottom"><div className="back">PCB Designing</div></div>
            </div>
            <div className="iotSol_para">PCB design with real-time monitoring, automated testing, and data analytics, optimizing manufacturing processes and quality assurance.</div>
          </div>
        </div>

        <div className="iotSol__sidebar">
          <h3>Need Assistance?</h3>
          <p>We can assist you</p>
          <div className="iotbtn">
            <Link to="/iotDetails" onClick={scrollToTop}><button className="iotbtn1">Explore More</button></Link>
            <HashLink to="/#incontact_section" onClick={scrollToTop} smooth><button className="iotbtn2">Reach Us</button></HashLink>
          </div>
        </div>
      </div>

      <div className="iotSol__below"></div>
    </div>
  );
}
